import './CartridgesSlider.scss';
import '@splidejs/react-splide/css';
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { Splide, SplideSlide } from '@splidejs/react-splide';

export const CartridgesSlider = ({cartridgeProducts}) => {
  const BASE_URL = 'img/ProductsImg';

  return (
    <div className="cartridges__slider">

      <Splide 
        aria-label="cartridges__all"
        id="slider__cartridges"
        options={{
          type: "loop",
          drag: "free",
          focus: "center",
          pagination: false,
          perPage: 4,
          pauseOnHover: false,
          pauseOnFocus: false,
          autoScroll: { 
            // rewind: false,
            speed: 1,
          }
        }}
        extensions={{ AutoScroll }}
      >
        {cartridgeProducts.map(cartridge => (
          <SplideSlide key={cartridge.name}>
            <div className="cartridges__slider--photo">
              <img src={`${BASE_URL}${cartridge.images[0]}`} alt={`${cartridge.name}`} />
            </div>
          </SplideSlide>
        ))}
      </Splide>

    </div>
  );
}